<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">

        <el-container>
            <div width="360px">
                <div :class="$style.left">

                    <el-row>
                        <el-col :span="12">
                            <div style="padding-top: 8px">资料库</div>
                        </el-col>
                        <el-col :span="12">
                            <div align="right">
                                <el-button type="success" icon="el-icon-plus" size="small"
                                           @click.stop="addFolderClick(0)">
                                    新文件夹
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>

                    <el-autocomplete
                            v-model="input"
                            placeholder="请输入文件夹名称进行快速搜索"
                            :fetch-suggestions="search"
                            @select="handleSelect"
                            :class="$style.search">

                    <span slot-scope="{ item }">
                        <img :src="icon_forder" height="15px"
                             style="vertical-align: middle;margin-left: 4px"/>
                        <span style="margin-left: 21px;font-size: 14px;color: #555555">{{item.title}}</span>
                    </span>

                    </el-autocomplete>

                    <div ref="scrollbar" style="border: 1px solid #dedede;margin-top: 5px;min-height: 500px" >
                        <el-tree
                                ref="menusTree"
                                :data="folderArry"
                                :props="defaultProps"
                                :expand-on-click-node="false"
                                :auto-expand-parent="true"
                                node-key="_id"
                                :default-expanded-keys="defaultExpandedKeys"
                                @node-expand="handleNodeExpand"
                                @node-click="handleNodeClick"
                        >
                    <span style="margin-top: 20px;margin-bottom: 20px" slot-scope="{ node, data }">
                        <img :src="icon_forder" height="15px"
                             style="vertical-align: middle"/>
                        <!--<span :class="['iconfont', $style.first]" v-if="node.level === 1"></span>-->
                        <span :class="$style.font">{{node.label}}</span>
                    </span>
                        </el-tree>

                    </div>
                </div>
            </div>
            <el-main height="100%">
                <div :class="$style.right">

                    <div :class="$style.header">
                        <el-row style="padding-right: 20px; padding-left: 20px;">
                            <el-col :span="2">
                                <div style="padding-top: 8px">文件夹</div>
                            </el-col>
                            <el-col :span="10">
                                <div align="left" style="padding-top: 8px; color: cornflowerblue">{{companyName}}</div>
                            </el-col>
                            <el-col :span="12">
                                <div align="right">
                                    <el-button type="warning" size="small" @click.stop="addFolderClick(1)"
                                               :disabled="!companyName">
                                        编辑
                                    </el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <!--<div :class="$style.header">-->
                    <!--<span>文件夹</span>-->
                    <!--<span>{{companyName}}</span>-->

                    <!--</div>-->

                    <!--<div align="right">-->
                    <!--<el-button type="primary" icon="el-icon-edit">编辑</el-button>-->
                    <!--</div>-->


                    <div :class="$style.body">
                        <!--<router-view></router-view>-->
                        <!--<el-scrollbar :class="$style.scrollbar" >-->
                        <router-view :key="key"></router-view>
                        <!--</el-scrollbar>-->
                    </div>
                </div>
            </el-main>
        </el-container>


        <div :class="$style.title">


        </div>
        <el-dialog
                :visible.sync="dialogVisible"
                width="35%"
                :show-close="false"
                :before-close="handleClose"

                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">

                <el-row>
                    <el-col :span="12">
                        <div style="color: #3998F7;font-weight: bold;padding-top: 8px;font-size: 16px">{{file_title}}
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="saveFolder" :disabled="!folderName">
                                保存
                            </el-button>
                        </div>
                    </el-col>
                </el-row>


                <div class="subjectList" style="margin-top: 20px;">

                    <el-form ref="form" label-width="100px">
                        <el-form-item label="文件夹名称">
                            <el-input v-model="folderName" placeholder="请输入文件夹名称"></el-input>
                        </el-form-item>
                    </el-form>

                </div>

            </div>

        </el-dialog>
    </div>

</template>


<script>
    // import TreeNode from './components/treeNode'
    import http from '../../../../APIService/http'
    // import {bus} from '../../../../router/router'
    import ImgUrl_n_red from '../../../../assets/images/folder_icon.png'
    import { MessageBox, Message } from 'element-ui';

    export default {
        data() {
            return {
                dialogVisible: false,
                isFirst: true,
                loading: false,
                userId: '',
                input: '',
                queryString: '',
                oldtreeNodes: [{"id": "id01", "value": "文件夹1"}, {"id": "id02", "value": "文件夹2"}],
                folderArry: [],
                timeout: null,
                options: [],
                distributorInfo: [],
                storeInfo: [],
                defaultExpandedKeys: [],
                total: 0,
                showDistributor: false,
                showStore: false,
                showCompany: true,
                companyName: '',
                branchId: '',

                file_title: '',
                folderName: '',
                icon_forder: ImgUrl_n_red,

                clientHeight: '',

                defaultProps: {
                    label: 'title'
                },
            }
        },

        async created() {

//            let obj = this.$store.getters.getUser || {}
//
//            this.userId = obj._id
//
            this.getForderList()
        },
        computed: {
            distributorName() {
                let store = this.$store.getters.getStore || {}
                if (store.distributorName) {
                    return store.distributorName
                } else {
                    return ''
                }
            },
            key() {
                return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
            }
        },
        methods: {

            async getForderList() {
                this.loading = true
                try {

                    let data = {

                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,

                    }

                    await http.post('/wapi/v1/getForderList', data).then(res => {

                        this.folderArry = res.data.folderArry


                        if (this.folderArry.length > 0) {
                            let folderObj = this.folderArry[0]

                            this.companyName = folderObj.title

                            this.$store.commit('setDatabase', {
                                tenant_id: folderObj.tenant_id,
                                library_id: folderObj.library_id,
                                catalog_id: folderObj.catalog_id,
                                title: folderObj.title
                            })
                        }

                        this.$router.push({
                            path: '/system/dataHome/dataIndex'
                        })

                        this.loading = false

                    })
                    //
                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },
            handleClose(done) {
//                this.$confirm('确认关闭？')
//                    .then(_ => {
                done();
//                    })
//                    .catch(_ => {});
            },
            addFolderClick(num) {

                this.dialogVisible = true

                if (num === 0) {

                    this.file_title = '新建文件夹'
                    this.folderName = ''
                } else {
                    let detabaseObj = this.$store.getters.getDatabase
                    this.file_title = '编辑文件夹'
                    this.folderName = detabaseObj.title
                }
            },
            async saveFolder() {
                if (this.file_title === '新建文件夹') {
                    this.addEditFolder(false)
                } else if (this.file_title === '编辑文件夹') {
                    this.addEditFolder(true)
                }
            },
            async addEditFolder(isEdit) {
                try {
                    this.loading = true

                    let detabaseObj = this.$store.getters.getDatabase

                    let data
                    if (!isEdit) {
                        data = {
                            tenant_id: this.$store.getters.getUser.tenant_id,
                            user_id: this.$store.getters.getUser.user_id,
                            title: this.folderName,
                            isEdit: isEdit
                        }
                    } else {
                        data = {
                            tenant_id: this.$store.getters.getUser.tenant_id,
                            user_id: this.$store.getters.getUser.user_id,
                            library_id: detabaseObj.library_id,
                            catalog_id: detabaseObj.catalog_id,
                            title: this.folderName,
                            isEdit: isEdit
                        }
                    }


                    await http.post('/wapi/v1/addEditFolder', data).then(res => {

                        let success = res.success

                        if (success) {
                            this.getForderList()
                            this.dialogVisible = false
                        }

                        this.loading = false


                    })
                } catch (err) {
                    this.loading = false
                    Message.error("添加失败")
                }
            },
            async search(queryString, cb) {

                this.queryString = queryString.trim()
                if (queryString) {

                    try {

                        let data = {

                            tenant_id: this.$store.getters.getUser.tenant_id,
                            user_id: this.$store.getters.getUser.user_id,
                            search: queryString

                        }

                        await http.post('/wapi/v1/getForderList', data).then(res => {

                            cb(res.data.folderArry);

                        })

                    } catch (err) {
                        console.log(`error:${err}`)
                    }

                } else {
                    cp([])
                }
            },
            createStateFilter(queryString) {
                return (state) => {
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            //过滤
            handleSelect(item) {

                this.companyName = item.title

                this.$store.commit('setDatabase', {
                    tenant_id: item.tenant_id,
                    library_id: item.library_id,
                    catalog_id: item.catalog_id,
                    title: item.title
                })

                this.$router.push({
                    path: '/system/dataHome/dataIndex'
                })
            },


            // 节点被展开
            handleNodeExpand(data, node) {


            },
            // 节点被点击
            handleNodeClick(data, node) {

                this.companyName = data.title

                this.$store.commit('setDatabase', {
                    tenant_id: data.tenant_id,
                    library_id: data.library_id,
                    catalog_id: data.catalog_id,
                    title: data.title
                })

                this.$router.push({
                    path: '/system/dataHome/dataIndex'
                })


            },
            async refreshStore(rowObj) {
                if (rowObj.isEdit) {

                    // for (const ind of this.treeNodes) {
                    //     if (ind._id === rowObj.branchId) {//分公司
                    //         for (const item of ind.children) {
                    //             if (item._id === rowObj.dealerId) {//经销商
                    //                 for (const itemObj of item.children) {
                    //                     if (itemObj._id === rowObj.id) {
                    //
                    //                         itemObj.address = rowObj.address
                    //                         itemObj.status = rowObj.status
                    //
                    //                         if (itemObj.status === "INACTIVE") {
                    //                             itemObj.name = '(撤) ' + rowObj.name
                    //                         } else {
                    //                             itemObj.name = rowObj.name
                    //                         }
                    //
                    //
                    //                         break
                    //                     }
                    //                 }
                    //
                    //             }
                    //         }
                    //         let obj = this.$store.getters.getMyStore
                    //
                    //         if (obj.index) {
                    //             obj.index = false
                    //             this.$router.push({
                    //                 path: '/store/index1'
                    //             })
                    //         }
                    //         else {
                    //             obj.index = true
                    //             this.$router.push({
                    //                 path: '/store/index'
                    //             })
                    //         }
                    //     }
                    // }
                } else {//新增  刷新

                    // for (const ind of this.treeNodes) {
                    //     if (ind._id === rowObj.branchId) {//分公司
                    //         if (!ind.children) {
                    //             continue
                    //         }
                    //         for (const item of ind.children) {
                    //             if (item._id === rowObj.dealerId) {//经销商
                    //                 if (!item.children) {
                    //                     item.children = []
                    //                 }
                    //                 item.children.push({
                    //                     _id: rowObj.id,
                    //                     name: rowObj.name,
                    //                     address: rowObj.address,
                    //                     status: rowObj.status
                    //                 })
                    //
                    //                 let obj = this.$store.getters.getMyStore
                    //
                    //                 if (obj.index) {
                    //                     obj.index = false
                    //                     this.$router.push({
                    //                         path: '/store/index1'
                    //                     })
                    //                 }
                    //                 else {
                    //                     obj.index = true
                    //                     this.$router.push({
                    //                         path: '/store/index'
                    //                     })
                    //                 }
                    //                 break
                    //             }
                    //         }
                    //
                    //     }
                    // }

                }
            },
            // 获取点击的经销商信息
            getDistributorInfo(data, total) {

                this.distributorInfo = data
                this.total = total
            },
            // 获取点击的门店信息
            getStoreInfo(data) {

                this.storeInfo = data
            },
            getBrachInfo(data) {
                this.brachInfo = data
            }
        }
    }
</script>
<style lang="scss" module>
    .container {
        padding-top: 20px;
        padding-right: 20px;
        padding-left: 20px;
        padding-bottom: 20px;
        background: #fff;
        height: 110%;

        .left {
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            .search {
                margin-top: 20px;
                width: 360px;

            }
            .type {
                em {
                    color: #d98f2f;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .first {
                color: #555555;
                font-size: 20px;
            }
            .font {
                margin-left: 20px;
                font-size: 14px;
                color: #555555;
            }
        }
        .right {
            margin-top: -20px;
            width: 100%;
            .header {
                width: 100%;
                padding-bottom: 10px;
                border-bottom: 2px dotted #e7eaec;

            }
            .body {
                /*background-color: aqua;*/
                padding: 20px;
                /*margin-top: 40px;*/

            }
        }

        .noData {

        }
    }
</style>
<style scoped>
    .subjectList >>> .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
    }
</style>





// WEBPACK FOOTER //
// src/pages/develop/components/database/home.vue